import React from "react";

const PersonalInformation = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        A.
        <span className="text-[#01A7D1] ">
          {" "}
          COLLECTION OF YOUR PERSONAL INFORMATION
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. COLLECTION OF PERSONAL INFORMATION
        </h1>
        “Personal information” is defined to include information that whether on
        its own or in combination with other information may be used to readily
        identify or contact you such as: name, address, email address, phone
        number etc.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The type of personal information that we collect from you varies based
        on your particular interaction with our Website. Personal information
        collected shall include but is not limited to your name, gender, age,
        account password, postal address, phone number, email address, contact
        preferences, ID proof (PAN, Passport, Aadhar, Voter ID etc.), bank
        account/credit card/debit card details, proof of employment, proof of
        educational background, and other information that would assist us in
        verifying your identity.
        <br />
        We may also collect personal information that you post in your profile,
        requests or feedback, and any comments or discussions you post in any
        blog, chat room, or other correspondence site on the Platform. Yostel
        reserves the right to record the conversations and correspondences
        between the Platform users. All the chat/messaging logs or call
        recordings can be used to but not limited to monitor and prohibit abuse,
        safeguard the rights of users, resolve disputes etc.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        We may also collect personal information that you post in your profile,
        requests or feedback, and any comments or discussions you post in any
        blog, chat room, or other correspondence site on the Website. Yostel
        reserves the right to record the conversations and correspondences
        between the Website users. All the chat/messaging logs or call
        recordings can be used to but not limited to monitor and prohibit abuse,
        safeguard the rights of users, resolve disputes etc.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        If we deem it necessary, in our sole and absolute discretion, we may
        also ask for and collect supplemental information from third parties,
        such as information about your credit from a credit bureau (to the
        extent permitted by law), or information to verify any identification
        details you provide during registration.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You undertake that your personal information shall at all times be
        accurate, complete and up to date. We shall also make reasonable efforts
        to provide you with the opportunity to request correction of your
        personal information provided to us if the same is inaccurate; or even
        to delete the personal information, if so requested and subject to
        applicable law. Further, we may decline to process requests which we
        find to be contrary to the terms laid down under this Policy, Platform
        Terms and Conditions or any applicable laws, require disproportionate
        technical effort, jeopardize the privacy of others or are extremely
        impractical.
      </p>
    </div>
  );
};

export default PersonalInformation;
